export const DEBOUNCE_DELAY = process.env.REACT_APP_DEBOUNCE_DELAY;
export const API_RECORDS_COUNT = 50;
export const SOURCE_PARAM_KEY = "source";
export const REDIRECT_SOURCES = {
  ADMIN: "admin",
};
// Authentication
export const AUTH_TOKEN_KEY = process.env.APP_COOKIE_NAME || "user_token";
export const ONBOARDING_URL = process.env.REACT_APP_ONBOARDING_URL;
export const MEMBERS_PLATFORM_URL = process.env.REACT_APP_MEMBERS_PLATFORM_URL;

export const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc",
}

export const KEILOT_WHATSAPP_NUMBER = process.env.REACT_APP_KEILOT_WHATSAPP_NUMBER;
export const KEILOT_MAIL_ADDRESS = "contact@keilot.com";